// src/i18n/he.ts
// ============================================================================
// Hebrew UI Copy — FULL SSOT (extracted from core.ts)
// Text only — NO logic, NO URLs, NO React
// ============================================================================

export const he = {
  meta: {
    lang: 'he',
    langFull: 'he-IL',
    dir: 'rtl' as const,
    name: 'עברית',
  },

  // ─────────────────────────────────────────────────────────────
  // WORDS
  // ─────────────────────────────────────────────────────────────

  words: {
    dj: {
      he: `דיג׳יי`,
      he_alt: `די ג׳יי`,
      he_plain: `דיגיי`,
      en: `DJ`,
    },
    music: 'מוזיקה',   

    mc: `תקליטן`,

    events: {
      wedding: { one: `חתונה`, many: `חתונות`, to: `לחתונה` },
      henna: { one: `חינה`, many: `חינות`, to: `לחינה` },
      bar_bat: { one: `בר/בת מצווה`, many: `בר/בת מצוות`, to: `לבר/בת מצווה` },
      generic: { one: `אירוע`, many: `אירועים`, to: `לאירוע` },
    },

    albums: {
      forum: `פורום`,
      articles: `כתבות`,
      recommendations: `המלצות`,
      bars: `ברים`,
      flyers: `פלאיירים`,
    },

    phrases: {
      music_for_events: `מוזיקה לאירועים`,
      company_or_private: `חברה / פרטי`,
    },
  },

  business: {
    name: 'די ג׳יי אליאור מור - מוזיקה לאירועים',
  
    address: {
      street: 'מבצע יואב 16',
      city: 'באר שבע',
      postal: '8445914',
      country: 'IL',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // BRAND
  // ─────────────────────────────────────────────────────────────

  brand: {
    firstName: `אליאור`,
    short: `אליאור מור`,
    title: `די ג׳יי אליאור מור`,
  },

  metaDescription: {
    wedding:
      'מעל 15 שנות ניסיון בחתונות: פסקול אישי, קריאת קהל חדה, מיקסים מדויקים ושילוב סגנונות, רחבה מלאה לאורך כל החתונה – דיג׳יי לחתונה – מקצועי ומומלץ',
  
    henna:
      'מעל 15 שנות ניסיון בחינות: שילוב מסורת, דרבוקות ומוזיקה עדכנית, אווירה צבעונית ורחבה מלאה לאורך כל החינה – דיג׳יי לחינה – מקצועי ומומלץ',
  
    barBat:
      'מעל 15 שנות ניסיון באירועי בר/בת מצווה: כניסה מרגשת, להיטים שהנוער והמבוגרים אוהבים ורחבה מלאה מהשיר הראשון עד האחרון – דיג׳יי לבר/בת מצווה – מקצועי ומומלץ',
  
    generic:
      'מעל 15 שנות ניסיון באירועים: בניית קו מוזיקלי, קריאת קהל חדה ושילוב סגנונות, רחבה מלאה לאורך כל האירוע – דיג׳יי לאירוע – מקצועי ומומלץ',
  },

  // ─────────────────────────────────────────────────────────────
  // HOME
  // ─────────────────────────────────────────────────────────────

  home: {
    title: `מוזיקה לאירועים | די ג׳יי אליאור מור`,

    description:
      `אליאור מור – די ג׳יי עם מעל 15 שנות ניסיון בחתונות, חינות, בר/בת מצווה ואירועים. ` +
      `קריאת קהל חדה, שילוב סגנונות ומיקסים מדוייקים שיוצרים רחבה מלאה וחוויה מוזיקלית בלתי נשכחת.`,

    heroTitle: `אליאור מור – מוזיקה לאירועים`,


    sections: {
      section1Lines: (
        eventOne: string,
        mcLabel: string,
        brandTitle: string
      ) => [
        `מעל 15 שנות ניסיון שמבטיחות ${eventOne} מושלם`,
        'מוזיקה מדויקת וקריאת קהל חדה',
        'סאונד מקצועי ומיקסים מושלמים',
        `${eventOne} עם וייב שמח ואנרגטי`,
        `פלייליסט שמתאים בדיוק ל${eventOne} שלכם`,
        'חוויה מוזיקלית שלא שוכחים',
        `${brandTitle} - ${mcLabel} ל${eventOne} מושלם`,
      ],
    
      section2DescriptionSuffix: (eventOne: string) =>
        `כדי שכל ${eventOne} יהפוך לחוויה בלתי-נשכחת שהאורחים ידברו עליה עוד הרבה אחרי.`,
    
      section2AdditionalSuffix: '',
    
      section5SubtitleDesktop: (
        weddingOne: string,
        hennaOne: string,
        barBatOne: string,
        genericOne: string
      ) =>
        `בין אם זו ${weddingOne}, ${hennaOne}, ${barBatOne} או כל ${genericOne} אחר – אני מתאים את המוזיקה לאופי הקהל ולאווירה שאתם רוצים ליצור. עם תזמון מדויק, קריאת קהל חדה ושילוב חכם בין סגנונות, הערב זורם בקצב נכון שמרים את האנרגיות ומשאיר את הרחבה מלאה. בזכות שנים של ניסיון מול קהלים מגוונים, אני יוצר רצף מוזיקלי טבעי, מרגש ומחבר – מהצליל הראשון ועד האחרון.`,
    
      section5SubtitleMobile: (
        weddingMany: string,
        hennaMany: string,
        barBatOne: string,
        genericMany: string,
        genericOne: string
      ) =>
        `${weddingMany}, ${hennaMany}, ${barBatOne} ו${genericMany} עסקיים – אני מתאים את המוזיקה לקהל שלכם ומרים רחבה מלאה ושמחה עד סוף ה${genericOne}.`,
    
      section6Title: (brandTitle: string) =>
        `ביקורות והמלצות על ${brandTitle}`,
    
      section6Subtitle: (genericOne: string) =>
        `מה לקוחות מספרים על החוויה איתי ברחבה? ביקורות אמיתיות על המוזיקה, האנרגיה והליווי מהשיחה הראשונה ועד סוף ה${genericOne}.`,
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 1 — OPEN
  // ────────────────────────────────────────────────────────────

  section1: {  
    targetPageLines: {
      base: [
        'יותר מ־15 שנות ניסיון בכל סוגי האירועים',
        'מוזיקה שנבנית לפי הקצב של הקהל שלכם',
        'קריאת קהל מדויקת ואווירה שעושה חשק לרקוד',
        'רחבה מלאה ושמחה שנמשכת עד השעות הקטנות',
      ],
    
      wedding: [
        'מעל 15 שנות ניסיון בחתונות',
        'מוזיקה מדויקת לכל רגע בחתונה',
        'בניית פסקול אישי שמותאם בדיוק אליכם',
        'מיקסים מושלמים וקריאת קהל חדה',
        'ליווי מקצועי ותכנון מוזיקלי מלא',
        'חתונה שהאורחים לא מפסיקים לדבר עליה',
      ],
    
      henna: [
        'חינה מרגשת עם וייב אותנטי',
        'אווירה צבעונית שמחה וחגיגית',
        'שילוב מושלם של מסורת ומודרניות',
        'דרבוקות ומקצבים שמרימים את כל המשפחה',
        'פלייליסט שמתאים בדיוק לחינה שלכם',
        'טקס חינה מרגש עם אווירה מחשמלת',
      ],
    
      bar_bat: [
        'מעל 15 שנות ניסיון בבר/בת מצוות',
        'כניסה מרגשת שהאורחים לא שוכחים',
        'רחבה מלאה מהשיר הראשון עד האחרון',
        'להיטים עדכניים שהנוער והמבוגרים אוהבים',
        'אווירה משפחתית ושמחה',
        'חוויה מוזיקלית שנשארת בזיכרון',
      ],
    
      event: [
        'מעל 15 שנות ניסיון בכל סוגי האירועים',
        'מוזיקה מדויקת וקריאת קהל חדה',
        'סאונד מקצועי ומיקסים מושלמים',
        'אירוע עם וייב שמח ואנרגטי',
        'פלייליסט שמתאים בדיוק לאירוע שלכם',
        'חוויה מוזיקלית שלא שוכחים',
      ],
    },
    hub: {
      city: {
        descriptionLines: (
          keyword: string,
          cityBet: string,
          brandTitle: string
        ) => [
          '15 שנות ניסיון שמדברות מעצמן',
          'מוזיקה שמתאימה לכל סגנון של קהל',
          'יודע להרגיש את הרחבה ולתת את השיר הנכון',
          'אווירה שמחה מתחילת האירוע ועד הסוף',
          `${brandTitle} – ${keyword}${cityBet}`,
        ],
    
        extraHeadings: (keyword: string, cityBet: string) => [
          `איך לבחור ${keyword}${cityBet} בצורה נכונה`,
          `סוגי אירועים פופולריים${cityBet}`,
        ],
      },
    
      region: {
        descriptionLines: (
          keyword: string,
          regionBet: string,
          brandTitle: string
        ) => [
          'יותר מ־15 שנות ניסיון שמדברים בעד עצמם',
          'מוזיקה מגוונת שמתאימה לכל סוג קהל',
          'רחבת ריקודים שמלאה באנרגיה ושמחה',
          'אווירה חגיגית שנמשכת כל הערב',
          `${brandTitle} – ${keyword}${regionBet}`,
        ],
    
        extraHeadings: (keyword: string, regionBet: string) => [
          `איך לבחור ${keyword}${regionBet}`,
          `ערים מובילות${regionBet} להתחלת החיפוש`,
        ],
      },
    
      home: {
        section1Lines: (eventOne: string, mcLabel: string, brandTitle: string) => [
          `מעל 15 שנות ניסיון שמבטיחות ${eventOne} מושלם`,
          'מוזיקה מדויקת וקריאת קהל חדה',
          'סאונד מקצועי ומיקסים מושלמים',
          `${eventOne} עם וייב שמח ואנרגטי`,
          `פלייליסט שמתאים בדיוק ל${eventOne} שלכם`,
          'חוויה מוזיקלית שלא שוכחים',
          `${brandTitle} - ${mcLabel} ל${eventOne} מושלם`,
        ],
      },
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 2 — ABOUT
  // ─────────────────────────────────────────────────────────────

  section2: {
    title: 'הסיפור שלי',

    description:
      `עם ניסיון של מעל 15 שנים על עמדת הדי ג׳יי, כולל עשור כתקליטן הבית במועדון הפורום – אני אליאור מור, דיג׳יי שמוביל את הערב בקצב הנכון ויוצר רגעים בלתי נשכחים. בכל אירוע אני מביא אנרגיה מחשמלת, קריאת קהל חדה, מיקסים מדויקים ומוזיקה שמרימה את הרחבה מהשיר הראשון ועד האחרון`,

    additionalText:
      'כל אירוע מבחינתי הוא הזדמנות להרים את הרחבה וליצור רגעים שאנשים זוכרים. המטרה שלי – לוודא שהאורחים נהנים מהאירוע מתחילתו ועד סופו. אני מחבר בין סגנונות, קורא את הקהל ומפתיע עם קטעים שלא שמעתם שנים. וזה מה שהופך את האירוע שלכם לחוויה שמרגישה ברמה אחרת.',

    imageAltPortrait: `אליאור מור על העמדה`,
    imageAltHorizontal: `אליאור מור – די ג׳יי שיודע להרים מסיבה`,

    targetAdditionalByService: {
      wedding:
        'חתונה היא סיפור אהבה שמקבל חיים דרך המוזיקה. חשוב לי קודם כל להכיר אתכם באמת – להבין מי אתם, מה מרגש אתכם ואיך אתם מדמיינים את החתונה שלכם. מתוך ההיכרות הזאת אנחנו בונים יחד פסקול אישי, מדייקים כל רגע ומעצבים יחד את האווירה, כדי להפוך את החלום שלכם למציאות ולחגיגה בלתי נשכחת מהצליל הראשון ועד שיר הסיום.',
    
      henna:
        'כל חינה היא חגיגה צבעונית שאני בונה בקפידה מהרגע הראשון. המטרה שלי פשוטה – אווירה שמחה, קצב שמרים את כולם ורחבה מלאה. אני משלב בין מסורת לקצב עכשווי ויוצר זרימה שלא נותנת לאורחים לשבת.',
    
      bar_bat:
        'כל בר/בת מצווה היא הזדמנות לייצר רגעים מיוחדים שמחברים בין כולם. המטרה שלי פשוטה – ליצור מסיבה שמרגישה טבעית לנוער וגם למבוגרים. עם שילוב נכון של שירים עדכניים וקלאסיקות אהובות, נוצרת חגיגה צעירה וסוחפת שכולם מרגישים חלק ממנה.',
    
      event:
        'כל אירוע הוא הזדמנות ליצור חוויה מוזיקלית מדויקת שמותאמת לקהל ולאופי האירוע. בעזרת קריאת קהל בזמן אמת, מעברים מוזיקליים חלקים ושילוב נכון בין סגנונות, נוצרת אווירה שמרימה את הרחבה ושומרת על אנרגיה גבוהה לאורך כל הערב. כך כל אירוע הופך לחגיגה שהאורחים זוכרים עוד הרבה אחרי שהאירוע מסתיים.',
    },
    
    targetAdditionalSuffixByService: {
      wedding:
        'אני מעניק לחתונה שלכם נגיעה אישית ודיוק שמורגש בכל רגע.',
    
      henna:
        'אני מוסיף לחינה שלכם טאצ׳ מיוחד שהופך אותה לאירוע מלא חיים.',
    
      bar_bat:
        'אני בונה לאירוע שלכם זהות מוזיקלית שמתאימה בדיוק למשפחה ולווייב שאתם רוצים ליצור.',
    
      event:
        'אני מדייק את המוזיקה כך שכל אירוע יקבל את האופי המיוחד שלו.',
    },

    fallbackSuffix:
   'כך האירוע שלכם מקבל וייב שמתאים בדיוק לקהל שלכם.',

    targetDescription: (
      baseDescription: string,
      djKeyword: string,
      cityBet: string
    ) =>
      `${baseDescription} אני ${djKeyword}${cityBet}, עם היכרות מעולה עם הקהל המקומי והאולמות באזור.`,

      targetAdditionalText: (
        base: string,
        cityBet: string,
        suffix: string
      ) => `${base} ${cityBet} ${suffix}`.replace(/\s+/g, ' ').trim(),
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 3 — GALLERY
  // ─────────────────────────────────────────────────────────────

  section3: {
    title: 'תנו לתמונות לדבר',
    fallbackText: 'בחר אלבום כדי לראות פרטים נוספים',
    albumsError: 'לא ניתן לטעון אלבומים. נסו שוב מאוחר יותר.',
    filesError: 'שגיאה בטעינת הקבצים.',
    loading: 'טוען גלריה…',

    galleryHeadings: {
      wedding: (keyword: string, cityBet: string) => [
        `תמונות מ${keyword}${cityBet} – חופה, סלואו ורחבה`,
        `רגעים מחתונות${cityBet} – אנרגיה על הרחבה`,
        `זוגות מאושרים וסטים בוערים – חתונות${cityBet}`,
      ],
    
      henna: (_keyword: string, cityBet: string) => [
        `גלריית חינה${cityBet} – צבע, מעגלים וקצב`,
        `מסורת ושמחה – חינות${cityBet} בתמונות`,
        `דרבוקות ואנרגיה – חינה${cityBet} ברגעים אמיתיים`,
      ],
    
      bar_bat: (_keyword: string, cityBet: string) => [
        `בר/בת מצווה${cityBet} – כניסה, רחבה ואווירה`,
        `נוער ומשפחה רוקדים – בר/בת מצווה${cityBet}`,
        `שיאים ותמונות חיות – בר/בת מצווה${cityBet}`,
      ],
    
      event: (_keyword: string, cityBet: string) => [
        `היילייטס מאירועים${cityBet} – רחבות מלאות`,
        `סטייל מוזיקלי ואנרגיה – אירועים${cityBet}`,
        `גלריית אירועים${cityBet} – רגעים שלא שוכחים`,
      ],
    },

    albumDescriptions: {
      weddings:
        'תמונות מתוך חתונות אמיתיות – חופה, סלואו ורחבה בוערת. וייב שמרים את כל האורחים מהרגע הראשון ועד האחרון.',

      hennas:
        'צבע, תופים ומעגלים – חינות מלאות אנרגיה ושמחה עם שילוב מושלם בין מסורת לוייב עכשווי.',

      barBat:
        'רגעים מבר/בת מצוות – כניסת מצווה, רחבת נוער ומשפחה, ואווירה מחשמלת שמחברת את כולם.',

      forum:
        'סטים מחשמלים ממועדון הפורום באר שבע, שם שימשתי כרזידנט עשור. אווירה של 3,000 חוגגים בכל סוף שבוע.',

      articles:
        'אוסף כתבות, ראיונות וסיקורים תקשורתיים – הסיפורים והאירועים שמאחורי המוזיקה.',

      recommendations:
        'טסטימוניאלס אמיתיים מלקוחות – פידבקים, הודעות ומכתבי תודה אחרי לילות בלתי נשכחים.',

      bars:
        'סטים מברים ומקומות בילוי ברחבי הארץ – מוזיקה מדויקת לקהל וערבים מלאי אנרגיה.',

      flyers:
        'אוסף הפלאיירים מערבי מועדונים ואירועים – כל אחד מספר סיפור של לילה חם במיוחד.',
    },

    albumTexts: {
      weddings:
        'מעבר למוזיקה עצמה, חשוב לי ללוות אתכם לחתונה לאורך כל הדרך. אני מביא איתי ניסיון של מאות זוגות מרוצים, ראייה רחבה של החתונה ותשומת לב לפרטים הקטנים שעושים את ההבדל. המטרה שלי היא לתת לכם שקט נפשי, ביטחון מקצועי וידיעה שיש מי שמוביל את החתונה בצורה מדויקת.',

      forum:
        'פורום באר שבע – מועדון ברמה בינלאומית שבו שימשתי כרזידנט במשך 10 שנים, עם סטים מחשמלים מול 3,000 חוגגים בכל סוף שבוע. מוזיקה עדכנית, אפקטים עוצמתיים ואווירה שאין כמוה בישראל',

      articles:
        'אוסף כתבות שהתפרסמו עליי במדיה הארצית והמקומית, הכוללות ראיונות, סיפורים ותיעוד אירועים מיוחדים בהם השתתפתי, ומשקפות את הדרך והעשייה המוזיקלית שלי לאורך השנים',

      hennas:
        'חינות הן השילוב המושלם בין מסורת, צבע ושמחה מתפרצת. עם מוזיקה אותנטית, תופים מרעידים ואנרגיות שמרימות את האולם, אני יוצר חוויית חינה עוצמתית ובלתי נשכחת. ניסיון של שנים בהובלת אירועי חינה מבטיח שכל האורחים, צעירים ומבוגרים, יישארו על הרגליים וירקדו עד הרגע האחרון',

      recommendations:
        'דברי תודה והמלצות מלקוחות שחוו איתי אירועים מרגשים ומלאי אנרגיה. כל מכתב וכל הודעה הם עדות לאהבה ולחוויות שיצרנו יחד',

      barBat:
        'בר/בת מצווה הוא אירוע של פעם בחיים – ואני כאן כדי להפוך אותו לחגיגה אמיתית. שילוב מנצח של מוזיקה עדכנית עם להיטים על-זמניים, הפעלות מגניבות ואווירה מחשמלת. עם ניסיון עשיר בניהול אירועי בר/בת מצווה, אני מבטיח שכל האורחים, מהחבר׳ה של החוגג/ת ועד הסבא והסבתא, ייהנו מרגעים שייזכרו לנצח',

      bars:
        'במהלך הקריירה ניגנתי במגוון ברים ומקומות בילוי בכל רחבי הארץ. לכל מקום הבאתי את הסאונד והווייב הייחודי שלי, עם מוזיקה שמתאימה בדיוק לקהל ומייצרת אווירה מושלמת לבילוי',

      flyers:
        'אוסף הפלאיירים של המקומות בהם הופעתי – מהפורום בבאר שבע ועד ברים ואולמות בכל הארץ. כל פלאייר מספר את סיפורו של ערב מלא במוזיקה, אנשים ואנרגיות שבלתי אפשר לשכוח',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 4 — CONTACT / CTA
  // ─────────────────────────────────────────────────────────────

  section4: {
    title: 'שדרג את האירוע שלך',

    description:
      'מחפש/ת די ג׳יי לאירוע שלך?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה',

    groupTitles: {
      contact: 'יצירת קשר',
      events: 'קטגוריות אירועים',
      services: 'שירותים נוספים',
    },

    eventsIntro: {
      default: `מוזיקה מותאמת לכל סגנון אירוע, פרטי או עסקי.`,
  
      wedding: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – מהחופה ועד המסיבה, מוזיקה שמדויקת לכם ולאורחים.`,
  
      henna: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – שילוב של מקצבים מסורתיים וביטים עכשוויים, חגיגה צבעונית לכל המשפחה.`,
  
      bar_bat: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – להיטים עדכניים לצד קלאסיקות שכל הדורות נהנים מהם.`,
  
      event: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – מוזיקה מותאמת לכל סגנון אירוע, פרטי או עסקי.`,
    },

    servicesIntro: {
      wedding: (_keyword: string, cityBet: string) =>
        `תוספות לחתונות${cityBet}: תאורה לחתונה, הגברה מקצועית ואטרקציות לחתונה.`,
    
      henna: (_keyword: string, cityBet: string) =>
        `תוספות לחינות${cityBet}: דרבוקות לחינה, תאורה חמה ואטרקציות לחינה.`,
    
      bar_bat: (_keyword: string, cityBet: string) =>
        `תוספות לבר/בת מצוות${cityBet}: תאורה לבר/בת מצווה, סאונד איכותי ואטרקציות לבר/בת מצווה.`,
    
      event: (_keyword: string, cityBet: string) =>
        `תוספות לאירועים${cityBet}: תאורה, סאונד ואטרקציות מותאמות לכל סוג אירוע.`,
    },

    blockCopy: {
      withCity: (
        keyword: string,
        cityName: string,
        firstName: string
      ) => ({
        description:
          `מחפש/ת ${keyword} ב${cityName}?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה.`,
    
        whatsappPrefill:
          `שלום ${firstName}, מעוניין/ת ב${keyword} ב${cityName}`,
    
        linksHeading:
          `עמודים קשורים ל${keyword} ב${cityName}`,
      }),
    
      withoutCity: (
        keyword: string,
        eventName: string,
        firstName: string
      ) => ({
        description:
          `מחפש/ת ${keyword} ל${eventName} שלך?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה.`,
    
        whatsappPrefill:
          `שלום ${firstName}, מעוניין/ת ב${keyword} ל${eventName} שלי`,
    
        linksHeading:
          `עמודים קשורים ל${keyword}`,
      }),
    },
  
    contactSeo: {
      phone: `דברו איתי בטלפון – אשמח לענות על כל שאלה.`,
      whatsapp: `כתבו לי בוואטסאפ ותוך רגעים אחזור עם פרטים.`,
      email: `אפשר גם במייל – שלחו הודעה ואחזור אליכם בהקדם.`,
      instagram: `תציצו באינסטגרם – סרטונים ותמונות חיות מהרחבה.`,
      facebook: `בפייסבוק תמצאו המלצות וקטעים מאירועים אמיתיים.`,
      navigate: `קל להגיע – לחצו לנווט אליי ב-Google Maps.`,
    },

    contactButtons: {
      phone: 'שיחה',
      whatsapp: 'וואטסאפ',
      email: 'אימייל',
      instagram: 'אינסטגרם',
      facebook: 'פייסבוק',
      navigate: 'נווט אליי',
    },

 
      services: {
        sound: {
          label: 'הגברה',
          description: 'הגברה מקצועית – סאונד נקי וברור בכל חלל.',
        },
        light: {
          label: 'תאורה',
          description: 'תאורה דינמית – הופכת כל רחבה למשהו מיוחד.',
        },
        attractions: {
          label: 'אטרקציות',
          description: 'אטרקציות לאירוע – קונפטי, עשן כבד, בלונים ועוד.',
        },
        recording: {
          label: 'הקלטות',
          description: 'שירותי הקלטה – שיר סלואו, ברכות או כניסה מיוחדת.',
        },
      },

      eventsTexts: {
        wedding: (cityBet: string) =>
          `די ג׳יי לחתונה${cityBet} – מוזיקה שמתאימה בדיוק לזוג ולאורחים.`,
      
        henna: (cityBet: string) =>
          `די ג׳יי לחינה${cityBet} – שילוב מושלם של אותנטיות וביטים עדכניים.`,
      
        bar_bat: (cityBet: string) =>
          `די ג׳יי לבר/בת מצווה${cityBet} – להיטים לכל הדורות.`,
      
        event: (cityBet: string) =>
          `די ג׳יי לאירוע${cityBet} – חברה / פרטי, מותאם לכל סגנון.`,
      },

      groupTitlesSeo: {
        wedding: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים נוספות${cityBet}`,
          services: `שירותים משלימים לחתונה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        henna: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `עוד סוגי אירועים שאני מרים${cityBet}`,
          services: `שירותים משלימים לחינה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        bar_bat: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים פופולריות${cityBet}`,
          services: `שירותים משלימים לבר/בת מצווה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        event: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים שאני מכסה${cityBet}`,
          services: `שירותים משלימים לאירועים${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      },

    prefills: {
      wedding:
        'היי אליאור,\nאשמח לשמוע פרטים לגבי די ג׳יי לחתונה.',
      henna:
        'שלום אליאור,\nאני מתעניין בדי ג׳יי לחינה.',
      barBat:
        'היי,\nמחפש די ג׳יי לבר/בת מצווה – אפשר פרטים?',
      generic:
        'שלום,\nאני מחפש די ג׳יי לאירוע חברה / פרטי.',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — FAQ
  // ─────────────────────────────────────────────────────────────

  section5: {
    title: 'מידע נוסף ושאלות נפוצות',
    linksHeading: 'עמודים קשורים שכדאי לבדוק',
    headingsSeo: {
      wedding: (keyword: string, cityBet: string) => [
        `תכנון מוזיקלי לחתונה${cityBet} מהשיחה הראשונה ועד`,
        `השיר האחרון, לפי הסגנון שלכם והקהל שמגיע לחגוג אתכם.`,
        `קבלת פנים אלגנטית עם מוזיקה נכונה שמכניסה`,
        `את האורחים לאווירה טובה ומשאירה מקום לשיחות ולמפגש.`,
        `ליווי מלא לחופה עם בחירת שירים מדויקת`,
        `לכניסת החתן, הכלה ורגע שבירת הכוס.`,
        `מעבר מתוכנן מהחופה לריקודי הפתיחה כך`,
        `שהאירוע ממשיך באופן טבעי והאורחים מצטרפים לרחבה.`,
        `קטע סלואו מרגש שמבוסס על מי שאתם`,
        `כזוג ויוצר רגע אישי שלא שוכחים.`,
        `שילוב של שירים וסגנונות שמתאימים לכל`,
        `שלב בערב, כדי שהרחבה תישאר מלאה והאורחים ייהנו מכל רגע.`,
        `${keyword}${cityBet} שמלווה אתכם עד סוף הערב`,
        `עם מוזיקה שמחזיקה את האנרגיה גבוהה וחיוך אצל כולם.`,
      ],
    
      henna: (keyword: string, cityBet: string) => [
        `תכנון חינה${cityBet} לפי המסורת של המשפחה`,
        `והאווירה שאתם רוצים ליצור, עם מוזיקה שמתאימה לחינה שמחה וצבעונית.`,
        `כניסה ראשונה עם דרבוקות ותהלוכה שמרימה`,
        `את כולם ופותחת את הערב באנרגיה טובה.`,
        `ריקודים מזרחיים ושירים מוכרים מהעדות`,
        `השונות במשפחה, כדי שכל אחד ירגיש חלק מהחגיגה.`,
        `כניסה שנייה חגיגית עם שירים מסורתיים`,
        `ורגע שמרים את כל הרחבה, בלי החלפת תלבושות.`,
        `טקס החינה בליווי מוזיקה שמתאימה למריחת`,
        `החינה, לברכות ולמעגלים של המשפחה.`,
        `זמן לצילומים ומתנות עם מוזיקה`,
        `נעימה שמתאימה לרגעים האישיים.`,
        `${keyword}${cityBet} שמביא את השילוב הנכון בין`,
        `מסורת, שמחה ומוזיקה שאנשים אוהבים.`,
      ],
    
      bar_bat: (keyword: string, cityBet: string) => [
        `תכנון בר/בת מצווה${cityBet} עם מוזיקה שמדברת גם`,
        `לנוער וגם למבוגרים, כדי שכל אחד ירגיש חלק מהחגיגה.`,
        `קבלת פנים עם מוזיקה קלילה ונעימה שמכינה`,
        `את האורחים לערב ומאפשרת מפגשים וצילומים.`,
        `כניסת מצווה מתואמת מראש עם שיר שבוחרים יחד,`,
        `הכרזה ורגע כניסה שהחוגג או החוגגת מרגישים בו במרכז הבמה.`,
        `ליווי דרשה, סרטון או מצגת עם מוזיקה`,
        `שמוסיפה רגש ומדגישה את חשיבות הרגע.`,
        `סטים קצביים עם שירים עדכניים לנוער בשילוב מוזיקה`,
        `שמתאימה גם למבוגרים, כך שהרחבה נשארת מלאה מכל הגילים.`,
        `אפשרות לקטע ריקוד מיוחד או שי שהחוגג בוחר`,
        `ולרגע בו הוא עולה לעמדה ומרגיש חלק פעיל מהאירוע.`,
        `חלוקה של זוהרים ואביזרים לרחבה שיוצרים`,
        `אנרגיה צעירה ומעלים את רמת ההתלהבות של כולם.`,
        `${keyword}${cityBet} שמוביל את הערב כך`,
        `שהנוער נהנה מהמוזיקה שלהם והמבוגרים מרגישים חלק מהשמחה.`,
      ],
    
      event: (
        keyword: string,
        cityBet: string,
        hasCity: boolean
      ) => {
        if (!hasCity) {
          return [
            `הכול מתחיל בשיחה מקדימה כדי להבין אתכם,`,
            `את הקהל שלכם ואת סוג האירוע שאתם מתכננים.`,
            `לאחר מכן אני בונה תכנית מוזיקלית שמתאימה`,
            `לקבלת הפנים, לרגעים רשמיים ולשיאים של הערב.`,
            `ברגעים המיוחדים כמו טקסים משפחתיים או`,
            `רגעי הוקרה, המוזיקה מדגישה את הרגש ומקרבת בין האנשים.`,
            `בשלב הריקודים הקצב מותאם לקהל כדי`,
            `לשמור על אנרגיה טובה על הרחבה.`,
            `המעברים בין השירים נקיים ומתוכננים כך`,
            `שהאורחים מרגישים שהמוזיקה מתפתחת בצורה טבעית.`,
            `הסאונד מותאם לאולם ולכמות האורחים כדי`,
            `שהמוזיקה תשמע טוב בכל חלק באירוע.`,
            `${keyword} שיוצר ערב חם, מקצועי ובלתי־נשכח`,
            `שהאורחים זוכרים גם אחרי שהוא מסתיים.`,
          ];
        }
    
        return [
          `תכנון אירוע${cityBet} עם ${keyword} שמותאם לאופי`,
          `שלכם, לסוג הקהל ולמקום שבו חוגגים.`,
          `כבר בשלב קבלת הפנים המוזיקה מותאמת`,
          `למפגש בין האורחים ויוצרת אווירה נעימה להתחלה.`,
          `לרגעים רשמיים כמו ברכות, מצגת קצרה או`,
          `טקס משפחתי נבחרת מוזיקה שמדגישה את המשמעות של הרגע.`,
          `בהמשך הערב אני מעלה בהדרגה את הקצב`,
          `ומעביר את המיקוד לרחבת הריקודים בצורה טבעית.`,
          `במהלך הערב אני קורא את הקהל ומחליט מתי`,
          `לשלב סגנונות שונים כדי להשאיר את הרחבה פעילה.`,
          `הסאונד מותאם לגודל האולם ולקהל באירוע${cityBet} כדי`,
          `שכל מי שנמצא במקום ייהנה מהמוזיקה.`,
          `${keyword}${cityBet} שמלווה אתכם לכל אורך הערב`,
          `וגורם לאורחים לצאת מרוצים מהחוויה שעברו.`,
        ];
      },
    },
    eventTypeDescription: {
      wedding: {
        mobile: (city: string, cityBet: string) =>
          `המוזיקה בחתונה שלכם ${cityBet} נבנית סביב הסיפור והאווירה שאתם רוצים ליצור – מקבלת פנים נעימה, דרך החופה והרגעים המרגשים, ועד מסיבה מלאה באנרגיה שמחברת בין כל האורחים.`,
    
        desktop: (city: string, cityBet: string) =>
          `כדי להפוך את החתונה שלכם$ {cityBet} לחוויה בלתי נשכחת, אני יוצר עבורכם פסקול אישי שמותאם לכל שלב באירוע – מקבלת פנים אלגנטית ונעימה, דרך החופה והרגעים המרגשים, ועד מסיבה מלאה באנרגיה שמחברת בין כל האורחים. בעזרת קריאת קהל מדויקת, מעברים מוזיקליים חלקים ושילוב נכון בין סגנונות מוזיקליים, נבנית חוויה מוזיקלית שמובילה את האירוע לחגיגה אמיתית.`,
      },
    
      event: {
        mobile: (_city: string, cityBet: string) =>
          `בכל אירוע ${cityBet} אני מתאים את הסטייל המוזיקלי לאופי הקהל. המעברים חלקים, הפלייליסט מגוון והאנרגיה בונה אווירה מחשמלת שגורמת לכולם לרקוד.`,
    
        desktop: (_city: string, cityBet: string) =>
          `בכל אירוע ${cityBet} אני מתאים את הסאונד ואת סגנון המוזיקה לאופי הקהל ולמהות האירוע. עם שילוב נכון של להיטים, קלאסיקות, קצב מדויק ומעברים מקצועיים, אני יוצר אווירה עם חיבור מדויק לקהל – הערב רץ בקצב גבוה ומשאיר את כולם בתוך החוויה עד השיר האחרון.`,
      },
    
      bar_bat: {
        mobile: (_city: string, cityBet: string) =>
          `בר/בת מצווה ${cityBet} זו חגיגה של פעם בחיים. אני משלב להיטים עדכניים לנוער עם קלאסיקות שכל המשפחה אוהבת, יוצר רגעים של שיא ואווירה שכולם זוכרים.`,
    
        desktop: (_city: string, cityBet: string) =>
          `בר/בת מצווה ${cityBet} היא חגיגה של פעם בחיים, ואני יוצר שילוב מדויק בין מוזיקה עדכנית שהנוער אוהב לבין שירי מסיבה ועל־זמניים שכל המשפחה מתחברת אליהם. עם קצב נכון, רגעי שיא מרגשים ורחבה שמתמלאת באנרגיה, אני דואג שהאירוע יהיה שמח, צעיר ומלא זיכרונות טובים.`,
      },
    
      henna: {
        mobile: (_city: string, cityBet: string) =>
          `חינה${cityBet} היא מסורת צבעונית ושמחה. אני משלב מוזיקה אותנטית וקצב מודרני, דרבוקות ומעגלים – כדי להפוך את החינה שלכם למסיבה מלאה באנרגיה.`,
    
        desktop: (_city: string, cityBet: string) =>
          `חינה${cityBet} היא מסיבה צבעונית ומלאת מסורת, ואני מקפיד לשלב בין מוזיקה אותנטית שמחברת לשורשים לבין קצב מודרני שמרים את הרחבה. דרבוקות, מעגלים, מקצבים מזרחיים וסט עכשווי שמתאים לכל הגילאים – הכל כדי ליצור חוויה שמחה, חמה ומשפחתית שתשאיר את כולם עם חיוך גדול.`,
      },
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — RECOMENDS
  // ─────────────────────────────────────────────────────────────

  section6: {
    defaults: {
      title: (brandTitle: string) =>
        `ביקורות והמלצות על ${brandTitle}`,
    
      subtitle: (
        brandShort: string,
        keyword: string,
        cityBet: string
      ) =>
        `מה לקוחות מספרים על ${brandShort}?\nהמלצות על ${keyword}${cityBet} – חוות דעת אמיתיות על אנרגיה ברחבה, קריאת קהל ושירות מקצועי.`,
    },
  },

  // ─────────────────────────────────────────────────────────────
  // FOOTER
  // ─────────────────────────────────────────────────────────────

  footer: {
    copyright: (year: number) =>
      `© ${year} די ג׳יי אליאור מור – כל הזכויות שמורות`,
    recommendedPages: 'עוד עמודים מומלצים',
  },

  // ─────────────────────────────────────────────────────────────
  // MISC
  // ─────────────────────────────────────────────────────────────

  misc: {
    professional: 'מקצועי',
    recommended: 'מומלץ',
  },


  menu: {
    sections: [
      { id: 'home', label: 'בית' },
      { id: 'story', label: 'הסיפור שלי' },
      { id: 'gallery', label: 'גלריה' },
      { id: 'contact', label: 'דברו איתי' },
      { id: 'info', label: 'מידע נוסף' },
      { id: 'reviews', label: 'ביקורות' },
    ],
  },
    // ─────────────────────────────────────────────────────────────
  // SEO FAQ — Wedding
  // ─────────────────────────────────────────────────────────────

  seo: {
    faq: {
      wedding: [
        {
          q: `מה כולל שירות די ג׳יי לחתונה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה חתונה ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לחתונה {city}?`,
          a: `{city} טווח המחירים נע לרוב בין 4,000 ל־9,000 ₪, בהתאם לגודל החתונה, התאריך והציוד.`,
        },
        {
          q: `איך לבחור די ג׳יי לחתונה {city}?`,
          a: `חשוב לבחור די ג׳יי עם ניסיון מוכח בחתונות, יכולת קריאת קהל גבוהה וחיבור אישי לזוג. מומלץ לבדוק המלצות, לראות סרטונים מאירועים אמיתיים ולהרגיש שיש מי שמבין את הסגנון שלכם ויודע להוביל את הערב בצורה מקצועית.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבת הריקודים. למי שמעוניין, ניתן לשלב תאורת במה ותאורות עיצוב מתקדמות בהתאמה אישית לאופי האירוע. אני עובד עם ספקים מובילים בתחום, עם מגוון רחב של אפשרויות תאורה ועיצובי במה לבחירת הזוג, כאשר המחיר משתנה בהתאם לבחירה.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים בחתונה {city}?`,
          a: `בוודאי, ניתן לשלב נגנים חיים כמו סקסופוניסט, כנרית, דרבוקן או בוזוקי ליצירת אווירה ייחודית ומרגשת.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי בחתונה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירת הזוג ולמהלך האירוע.`,
        },
        {
          q: `האם די ג׳יי מקומי {city} מכיר את האולמות?`,
          a: `ברוב המקרים כן. היכרות עם אולמות וגני אירועים באזור מאפשרת עבודה חלקה מול צוות המקום, התאמה מדויקת של הסאונד והתאורה למבנה האולם והיערכות נכונה ללוח הזמנים של האירוע – מה שתורם לזרימה טובה ולחוויה מקצועית יותר לאורך הערב.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לחתונה {city}?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. מעבר לכך ניתן לשדרג ולבנות חבילה בהתאמה אישית הכוללת עמדות דיג׳יי מעוצבות, אפטר פארטי, חבילות סלואו ופרימיום, אטרקציות מיוחדות, נגנים חיים ותוספות שונות בהתאם לסגנון האירוע ולבחירת הזוג.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי תמיד מגיע עם ציוד חלופי ותכנית חירום.`,
        },
        {
          q: `איך בוחרים שירים לחופה?`,
          a: `בחירת שירי החופה נעשית יחד עם הזוג ובהתאמה אישית. בדרך כלל בוחרים שיר לכניסת החתן, שיר לכניסת הכלה ושיר לשבירת הכוס, ולעיתים משלבים גם קטעים מיוחדים נוספים. התהליך נעשה בתיאום מלא ותוך ירידה לפרטים הקטנים כדי ליצור רגע מרגש ומדויק.`,
        },
        {
          q: `כמה זמן מראש צריך לשריין די ג׳יי לחתונה {city}?`,
          a: `לפחות חצי שנה מראש, ובקיץ מומלץ אפילו שנה מראש.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת שירים מועדפים, שירים שלא תרצו שיתנגנו או רק כיוונים כלליים לסגנון המוזיקה.`,
        },
        {
          q: `מה האטרקציות הפופולריות לחתונה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, תאורת במה, נגנים חיים, קונפטי ועוד.`,
        },
      ],
      henna: [
        {
          q: `מה כולל שירות די ג׳יי לחינה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה חינה ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `אילו סוגי חינות קיימות?`,
          a: `יש מגוון סגנונות כמו חינה מרוקאית, תימנית, פרסית, טוניסאית ועוד. בפועל אפשר גם לשלב בין סגנונות, בהתאם למשפחה, למסורת ולווייב שאתם רוצים ליצור.`,
        },
        {
          q: `איך מתכננים את הכניסות של הארוס והארוסה בחינה {city}?`,
          a: `מתכננים מראש את סדר הכניסות, השירים לכל כניסה ואת הקצב של המעברים, כדי ליצור רגע מרגש ומרשים. אני מלווה אתכם בתיאום השירים והטיימינג מול המקום והמשפחה לפי מה שמתאים לכם.`,
        },
        {
          q: `האם אפשר לתכנן טקס מריחת חינה בצורה מסודרת?`,
          a: `כן. מתאמים מראש את סדר הטקס, המוזיקה לרגעים המרכזיים והמעבר לרחבה. המטרה היא לשמור על זרימה טובה בין הטקס לבין המסיבה, בלי “נפילות” באנרגיה.`,
        },
        {
          q: `איך משלבים את טקס הענקת הזהב בחינה?`,
          a: `בדרך כלל בוחרים שיר/ים מתאימים, מתזמנים את הרגע מול המשפחה והצלמים, ושומרים על רצף מכבד ומרגש. הכול נקבע מראש לפי אופי המשפחה והטקס שאתם רוצים.`,
        },
        {
          q: `האם אפשר לשלב לבוש מסורתי ותלבושות בחינה {city}?`,
          a: `בוודאי. לרוב מתכננים מראש את החלפות הלבוש והטיימינג שלהן, כדי שזה ישתלב נכון עם הטקס, הכניסות והצילום. מומלץ לתאם גם מול האולם או המפיק כדי שהכול ירוץ חלק.`,
        },
        {
          q: `כמה עולה די ג׳יי לחינה {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,500 ל־5,000 ₪, בהתאם לגודל החינה, התאריך, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך לבחור די ג׳יי לחינה {city}?`,
          a: `חשוב לבחור די ג׳יי שיודע לקרוא קהל, לשלב סגנונות שמתאימים לאופי החינה, ולהוביל ערב בצורה מקצועית. מומלץ לבדוק המלצות, לראות סרטונים מאירועים אמיתיים ולהרגיש שיש חיבור וגישה שמתאימה לכם.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי בחינה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירתכם ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לחינה?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. מעבר לכך ניתן לשדרג בהתאמה אישית: עמדות דיג׳יי מעוצבות, אפטר פארטי, חבילות פרימיום, שילוב נגנים חיים ותוספות שונות לפי הבחירה.`,
        },
        {
          q: `האם אפשר לשלב דרבוקות או נגנים חיים בחינה?`,
          a: `בוודאי. ניתן לשלב נגנים חיים כמו דרבוקות, שופרות, סקסופון, כנרית או בוזוקי – בהתאם לסגנון החינה ולבחירתכם.`,
        },
        {
          q: `מה האטרקציות הפופולריות בחינה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבה. למי שמעוניין, ניתן לשלב תאורת במה ותאורות עיצוב מתקדמות בהתאמה אישית. אני עובד עם ספקים מובילים בתחום ויש מגוון רחב של אפשרויות — המחיר משתנה בהתאם לבחירה.`,
        },
        {
          q: `איך בונים פלייליסט לחינה?`,
          a: `בונים יחד כיוונים מוזיקליים מראש: שירים שאתם אוהבים, שירים שלא תרצו שיתנגנו והעדפות סגנון. במהלך האירוע המוזיקה מותאמת גם לקהל ולרחבה בזמן אמת כדי לשמור על זרימה ואנרגיה.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת “לא לשים”, או רק כיוונים כלליים. זה הבסיס לבניית הערב, ובאירוע עצמו אני מתאים את המוזיקה לקהל כדי לשמור על רחבה פעילה.`,
        },
        {
          q: `איך להתאים מוזיקה לקהל מגוון בחינה?`,
          a: `התאמה לקהל מגוון נעשית דרך קריאת קהל בזמן אמת ושילוב נכון בין סגנונות, תקופות וקצבים שונים. המוזיקה נבנית בהדרגה בהתאם לאווירה כדי שכל קבוצות האורחים יתחברו וייהנו.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול די ג׳יי?`,
          a: `כדאי לוודא: מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, מה נדרש מצד המקום (חשמל או עמדה) והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע מוכן עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
      ],
      bar_bat: [
        {
          q: `מה כולל שירות די ג׳יי לבר/בת מצווה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה בר/בת מצווה ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `איך מתכננים כניסה מרשימה לחוגג/ת בבר/בת מצווה {city}?`,
          a: `מתכננים מראש שיר כניסה, טיימינג מדויק והעמדה של הקהל או המשפחה, ולעיתים משלבים גם אפקטים לפי בחירה. המטרה היא ליצור כניסה חזקה שמרימה את האנרגיה ומכניסה את כולם לאווירה.`,
        },
        {
          q: `האם אפשר לשלב ברכה או דרשה בבר/בת מצווה {city}?`,
          a: `כן. מתאמים מראש מתי זה קורה במהלך הערב, דואגים למיקרופון מתאים ולסאונד ברור, ומשלבים את זה בצורה זורמת שלא “עוצרת” את האירוע אלא משתלבת בו נכון.`,
        },
        {
          q: `איך שומרים על רחבה עם ילדים וגם מבוגרים בבר/בת מצווה?`,
          a: `באמצעות ניהול נכון של הסט: חלקים שמכוונים לנוער עם להיטים עדכניים, לצד מקטעים שמתאימים למשפחה. קריאת קהל בזמן אמת מאפשרת לשמור על זרימה ולקחת את הרחבה יחד.`,
        },
        {
          q: `איך מנהלים רחבת נוער כדי שלא תתפזר?`,
          a: `שומרים על רצף מוזיקלי נכון, מעבר חכם בין סגנונות, ועובדים במקצועיות מול האנרגיה של הקהל הצעיר. כשצריך מעלים הילוך, וכשצריך מאזנים כדי שהרחבה תישאר יציבה לאורך זמן.`,
        },
        {
          q: `האם אפשר לשלב משחקים או הפעלות כחלק מהמסיבה?`,
          a: `כן, לפי בחירה. אפשר לשלב מנחה או רקדנים או הפעלות רחבה שיתאימו לסגנון של החוגג או החוגגת ולקהל. חשוב שזה יהיה בטעם טוב ובתיאום מראש כדי לשמור על זרימה ולא להעמיס.`,
        },
        {
          q: `כמה עולה די ג׳יי לבר/בת מצווה {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,500 ל־4,500 ₪, בהתאם לגודל האירוע, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך בוחרים די ג׳יי לבר/בת מצווה {city}?`,
          a: `חשוב לבחור די ג׳יי שיודע לעבוד עם קהל צעיר, לקרוא רחבה בזמן אמת ולשלב בין מוזיקה עדכנית לשירים שמתאימים גם למשפחה ולאורחים.`,
        },
        {
          q: `איך בוחרים שירים לבר/בת מצווה?`,
          a: `החוגג או החוגגת בוחרים שירים אהובים וכיוונים מוזיקליים מראש. במהלך האירוע המוזיקה מותאמת גם לאווירה ברחבה ולקהל כדי לשמור על זרימה ואנרגיה.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי בבר/בת מצווה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירה ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לבר/בת מצווה?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `האם אפשר לשלב רקדנים או מנחים בבר/בת מצווה?`,
          a: `בוודאי. ניתן לשלב רקדנים, מנחים או הפעלות רחבה שיוצרות אינטראקציה עם הקהל ומגבירות את האנרגיה במהלך האירוע.`,
        },
        {
          q: `מה האטרקציות הפופולריות לבר/בת מצווה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבה. ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית, בשיתוף ספקים מובילים בתחום ובהתאם לבחירה.`,
        },
        {
          q: `איך מתאימים מוזיקה לקהל מגוון בבר/בת מצווה?`,
          a: `התאמת מוזיקה לקהל מגוון נעשית באמצעות קריאת קהל בזמן אמת ושילוב נכון בין להיטים עדכניים, שירים אהובים על בני הנוער ומוזיקה שמתאימה גם למשפחה ולאורחים.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת לא לשים או רק כיוונים כלליים. הפלייליסט משמש בסיס, ובאירוע עצמו המוזיקה מותאמת לרחבה ולקהל.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול די ג׳יי?`,
          a: `כדאי לוודא מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, דרישות טכניות מהמקום והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `כמה זמן מראש כדאי להזמין די ג׳יי לבר/בת מצווה?`,
          a: `מומלץ לשריין לפחות 3–6 חודשים מראש, ובתאריכים מבוקשים אפילו מוקדם יותר.`,
        },
        {
          q: `האם אפשר לשלב וידאו או מצגת בבר/בת מצווה?`,
          a: `כן, ניתן לשלב מסכים להצגת קליפים, מצגות ותמונות אישיות במהלך האירוע וכן לשלב קטעי סאונד ווידאו כחלק מהשואו.`,
        },
      ],
      event: [
        {
          q: `מה כולל שירות די ג׳יי לאירוע חברה או פרטי {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה אירוע ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לאירוע {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,000 ל־5,000 ₪, בהתאם לסוג האירוע, גודל האירוע, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך בוחרים די ג׳יי לאירוע?`,
          a: `חשוב לבחור די ג׳יי עם ניסיון, יכולת קריאת קהל, המלצות מאירועים אמיתיים וחיבור לסגנון המוזיקלי שמתאים לאופי האירוע.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי באירוע?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירה ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לאירועים?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `האם די ג׳יי מתאים גם לאירועים קטנים?`,
          a: `כן, השירות מותאם גם לאירועים מצומצמים וגם לאירועים גדולים, בהתאם לאופי האירוע ולמקום.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב המקומות קיימת תאורה בסיסית לרחבה. ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית, בשיתוף ספקים מובילים ובהתאם לבחירה.`,
        },
        {
          q: `מה האטרקציות הפופולריות לאירועים {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם ניתן לקיים אירוע בשטח פתוח או בלוקיישן מיוחד?`,
          a: `כן, ניתן לקיים אירועים בשטח פתוח, חוף, גן או לוקיישן מיוחד. אירועים מסוג זה דורשים התאמה של מערכות סאונד, תאורה וציוד נוסף בהתאם למקום ולתנאי השטח.`,
        },
        {
          q: `איך מתאימים מוזיקה לקהל מגוון באירוע?`,
          a: `התאמת מוזיקה לקהל מגוון נעשית באמצעות קריאת קהל בזמן אמת ושילוב נכון בין סגנונות, תקופות וקצבים שונים כדי ליצור חיבור בין האורחים ולשמור על רחבה פעילה.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת לא לשים או רק כיוונים כלליים. הפלייליסט משמש בסיס, ובאירוע עצמו המוזיקה מותאמת לרחבה ולקהל.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים או מופע לייב?`,
          a: `כן, ניתן לשלב נגנים חיים כמו סקסופון, כנרית, דרבוקות, בוזוקי ונגנים נוספים בהתאם לסגנון האירוע ולבחירה האישית.`,
        },
        {
          q: `כמה זמן מראש כדאי לשריין די ג׳יי?`,
          a: `מומלץ לשריין לפחות 3–6 חודשים מראש, ובתאריכים מבוקשים אף מוקדם יותר.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול די ג׳יי?`,
          a: `כדאי לוודא מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, דרישות טכניות מהמקום והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `האם אפשר לשלב וידאו או מצגת באירוע?`,
          a: `כן, ניתן לשלב מסכים להצגת קליפים, מצגות ותמונות אישיות במהלך האירוע וכן לשלב קטעי סאונד ווידאו כחלק מהשואו.`,
        },
      ],
      homeEvent: [
        {
          q: `מה כולל שירות די ג׳יי לאירוע?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה אירוע ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לאירוע?`,
          a: `בדרך כלל טווח המחירים נע בין 2,000 ל־5,000 ₪, בהתאם לסוג האירוע, גודל האירוע, המיקום והתוספות שנבחרות.`,
        },
        {
          q: `לאילו סוגי אירועים אתה מתאים כדיג׳יי?`,
          a: `אני מתאים לחתונות, חינות, בר ובת מצווה, אירועי חברה, מסיבות עובדים, ימי גיבוש, מסיבות פרטיות ואירועים משפחתיים.`,
        },
        {
          q: `איך אתה מתאים מוזיקה לאירועים לקהל?`,
          a: `אני קורא את הרחבה בזמן אמת ומשלב בין סגנונות, תקופות וקצבים שונים בהתאם לאווירה ולקהל, כדי לשמור על רחבה פעילה לאורך כל האירוע.`,
        },
        {
          q: `האם יש לך ציוד דיג׳יי והגברה משלך?`,
          a: `כן. אני מגיע עם ציוד דיג׳יי מקצועי והגברה הכוללת רמקולים, מיקסר ומיקרופונים, בהתאם לצרכי המקום ולגודל האירוע.`,
        },
        {
          q: `האם אפשר לשלב גם תאורה באירוע?`,
          a: `ברוב המקומות קיימת תאורה בסיסית לרחבה. למי שמעוניין, ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית ובשיתוף ספקים מובילים, בהתאם לבחירה.`,
        },
        {
          q: `כמה זמן מראש כדאי לסגור די ג׳יי?`,
          a: `מומלץ לשריין כמה חודשים מראש, ובתאריכים מבוקשים או בעונות עמוסות אפילו מוקדם יותר כדי להבטיח זמינות.`,
        },
        {
          q: `האם די ג׳יי מתאים גם לאירועים קטנים ואינטימיים?`,
          a: `בהחלט. אני מתאים את עוצמת הסאונד, סגנון המוזיקה והאווירה גם לאירועים קטנים כמו מסיבות בית, גג, ימי הולדת ואירועים משפחתיים מצומצמים.`,
        },
        {
          q: `איך בוחרים די ג׳יי לאירוע?`,
          a: `מומלץ לבדוק ניסיון, המלצות מאירועים אמיתיים, סרטונים, סגנון מוזיקלי שמתאים לכם וכמובן חיבור אישי בשיחה או פגישה.`,
        },
        {
          q: `מה כוללות החבילות והאפשרויות לשדרוג?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `מה האטרקציות הפופולריות באירועים?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם יש גיבוי לציוד במקרה של תקלה?`,
          a: `כן. די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `האם אתה מנגן גם באירועי חברה וימי גיבוש?`,
          a: `כן, אני מנגן באירועי חברה, השקות, מסיבות עובדים וימי גיבוש ומתאים את המוזיקה לאופי הארגון והקהל.`,
        },
        {
          q: `איך בונים פלייליסט לאירוע?`,
          a: `בונים יחד כיוונים מוזיקליים, רשימת שירים חשובים ורשימת שירים שפחות מתאימים – ומשם אני בונה סט דינמי שמתאים לזרימה של הערב.`,
        },
        {
          q: `האם אפשר לשלוח רשימת שירים מראש?`,
          a: `בוודאי. ניתן לשלוח רשימת שירים אהובים, שירים שחייבים להתנגן ושירים שפחות מתאימים – ואני משלב אותם בצורה חכמה לאורך האירוע.`,
        },
        {
          q: `מה קורה אם האירוע מתארך?`,
          a: `אפשר להאריך את זמן הנגינה מעבר למה שסוכם מראש, בתיאום במקום ובתוספת תשלום לפי שעה.`,
        },
        {
          q: `האם מתקיים תיאום לפני האירוע?`,
          a: `כן, מומלץ לקיים שיחה או פגישה לפני האירוע כדי לעבור על לוח הזמנים, סגנונות המוזיקה, רגעי השיא ושירים חשובים עבורכם.`,
        },
      ],
    },
  },

// בתוך he
  // ─────────────────────────────────────────────────────────────
  // GEO — Regions & Cities (UI labels only)
  // ─────────────────────────────────────────────────────────────
  geo: {
    regions: {
      דרום: 'דרום',
      מרכז: 'מרכז',
    },

    cities: {
      'באר שבע': 'באר שבע',
      'אשקלון': 'אשקלון',
      'אשדוד': 'אשדוד',
      'קריית גת': 'קריית גת',
      'אופקים': 'אופקים',
      'נתיבות': 'נתיבות',
      'שדרות': 'שדרות',
      'להבים': 'להבים',
      'עומר': 'עומר',
      'דימונה': 'דימונה',
      'קריית מלאכי': 'קריית מלאכי',
      'ערד': 'ערד',
      'ירוחם': 'ירוחם',
      'מיתר': 'מיתר',
      'אילת': 'אילת',
      'קריית עקרון': 'קריית עקרון',
      'גן יבנה': 'גן יבנה',

      'תל אביב': 'תל אביב',
      'רמת גן': 'רמת גן',
      'גבעתיים': 'גבעתיים',
      'ראשון לציון': 'ראשון לציון',
      'חולון': 'חולון',
      'בת ים': 'בת ים',
      'רעננה': 'רעננה',
      'הרצליה': 'הרצליה',
      'פתח תקווה': 'פתח תקווה',
      'יבנה': 'יבנה',
      'רחובות': 'רחובות',
      'נס ציונה': 'נס ציונה',
      'כפר סבא': 'כפר סבא',
      'הוד השרון': 'הוד השרון',
      'מודיעין': 'מודיעין',
      'ראש העין': 'ראש העין',
      'נתניה': 'נתניה',
      'חדרה': 'חדרה',
      'עמק חפר': 'עמק חפר',
    },

    globalLabel: 'כל הארץ',
  },

} as const;

export type HePack = typeof he;